import { render, staticRenderFns } from "./IdeaGeneralCarton.vue?vue&type=template&id=1baf6a02&"
import script from "./IdeaGeneralCarton.vue?vue&type=script&lang=js&"
export * from "./IdeaGeneralCarton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports